import { DEFAULT_PAGINATION_CONFIG } from '@energy-stacks/core/ui';
import {
  GetJobsRequestBody,
  useGetPaginatedJobsQuery,
} from '@energy-stacks/fleet/feature-jobs-data';
import { toPayloadDate } from '@energy-stacks/shared';

interface GetJobsConfig {
  search: GetJobsRequestBody['searchValue'];
  pagination: {
    page: GetJobsRequestBody['page'];
    size: GetJobsRequestBody['size'];
  };
  sort: GetJobsRequestBody['sort'];
  startDate: Date | undefined;
  endDate: Date | undefined;
  statuses: GetJobsRequestBody['statuses'];
  jobTypes: GetJobsRequestBody['jobTypes'];
}

const MIN_SEARCH_CHARACTERS = 3;
const MAX_SEARCH_CHARACTERS = 255;

export const usePaginatedJobs = (config: GetJobsConfig, skip = false) => {
  const searchLength = config.search?.length ?? 0;

  return useGetPaginatedJobsQuery(
    {
      searchValue: config?.search ? config.search : undefined,
      page: config?.pagination?.page ?? DEFAULT_PAGINATION_CONFIG.page,
      size: config?.pagination?.size ?? DEFAULT_PAGINATION_CONFIG.size,
      sort: config?.sort,
      startDateTime: config.startDate
        ? toPayloadDate(config.startDate)
        : undefined,
      endDateTime: config.endDate ? toPayloadDate(config.endDate) : undefined,
      statuses: config.statuses ? config.statuses : undefined,
      jobTypes: config.jobTypes ? config.jobTypes : undefined,
    },
    {
      skip:
        skip ||
        Boolean(
          config.search &&
            (searchLength < MIN_SEARCH_CHARACTERS ||
              searchLength > MAX_SEARCH_CHARACTERS)
        ),
    }
  );
};
